"use client";
import { usePathname, useRouter } from "next/navigation";
import React from "react";
import { Search } from "lucide-react";
import { Utility } from "@/src/utils/utility";

const SearchBar = () => {
  const router = useRouter();

  const pathname = usePathname();

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = formData.get("name") as string;

    if (name.trim()) {
      // if (pathname.startsWith("/blog")) {
      //   router.push(`/blog/list?search=${encodeURIComponent(name.trim())}`);
      // } else {
      //   router.push(`/list?search=${encodeURIComponent(name.trim())}`);
      // }
      router.push(
        Utility.getRouteLinkUrl({
          main: `/list?search=${encodeURIComponent(name.trim())}`,
          blog: `/blog/list?search=${encodeURIComponent(name.trim())}`,
          tools: `/tools/list?search=${encodeURIComponent(name.trim())}`,
          pathname: pathname,
        }),
      );
    } else {
      // router.push(
      //   Utility.getRouteLinkUrl({
      //     main: `/list`,
      //     blog: `/blog/list`,
      //     tools: `/tools/list`,
      //     pathname: pathname,
      //   }),
      // );
    }
  };

  return (
    <form className="w-full" onSubmit={handleSearch} role="search" method="get">
      <div className="relative">
        <label htmlFor="search" className="sr-only" aria-label="search-label">
          Search
        </label>
        <input
          id="search"
          type="text"
          name="name"
          placeholder="Search..."
          className="ease w-full rounded-md border border-slate-200 bg-transparent py-2 pl-3 pr-10 text-sm shadow-sm transition duration-300 placeholder:text-slate-400 hover:border-slate-300 focus:border-slate-400 focus:shadow focus:outline-none"
          aria-label="Search"
        />
        <button type="submit" aria-label="Submit search">
          <Search className="absolute right-2.5 top-2.5 h-5 w-5 cursor-pointer text-slate-600" />
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
